import { LoadInPage, NotFoundPage } from '@lbcamden/lib-react';
import { FunctionComponent } from 'react';
import { useParams, useSearchParams } from 'react-router';

import { usePcfraPropertyDetails, useProperty } from '~/client/hooks/storeHooks';
import { useTinybaseStore } from '~/client/store/tinybase/tinybaseStore';
import { getPropertyValidity } from '~/client/utils/properties';

import { PageTitle } from '../../common/PageTitle';
import { InvalidPropertyMessage } from '../../shared/InvalidPropertyMessage';
import { PropertyHeader } from '../../shared/PageHeader';
import { SyncFailedMessage } from '../../shared/SyncFailedMessage';
import { CurrentResidents } from './CurrentResidents';

export const PcfraPropertyPage: FunctionComponent = () => {
  const { propertyId: propertyIdParam } = useParams();
  const propertyId = parseInt(propertyIdParam!);

  const [searchParams] = useSearchParams();
  const personId = searchParams.get('personId');
  const showPersonWithId = personId ? parseInt(personId) : undefined;

  const { isSyncing, hasSyncError, syncTimedOut } = useTinybaseStore(
    (state) => state.propertyDataSyncState,
  );
  const property = useProperty(propertyId);
  const { noResidentsFound } = usePcfraPropertyDetails(propertyId) || {};

  if (!property) {
    return <NotFoundPage />;
  }

  const syncFailed = hasSyncError || syncTimedOut;
  const validity = getPropertyValidity(property, noResidentsFound);

  return (
    <LoadInPage loading={isSyncing}>
      <PageTitle title={`PCFRA - ${property.address}`} />
      <PropertyHeader property={property} />
      {validity.isValid ? (
        <>
          {syncFailed && <SyncFailedMessage />}
          {!syncFailed && (
            <CurrentResidents propertyId={propertyId} showPersonWithId={showPersonWithId} />
          )}
        </>
      ) : (
        <InvalidPropertyMessage invalidPropertyKind={validity.reason!} isPcfra />
      )}
    </LoadInPage>
  );
};
